import type { EditorTrackControlState, EditorTrackKind, EditorTrackSettings } from '@/types/editor';

const DEFAULT_TRACK: EditorTrackControlState = { locked: false, hidden: false, muted: false };

export function defaultTrackSettings(): EditorTrackSettings {
  return {
    video: { ...DEFAULT_TRACK },
    music: { ...DEFAULT_TRACK },
    overlays: { ...DEFAULT_TRACK },
  };
}

export function cleanTrackSettings(value: unknown): EditorTrackSettings {
  const source = value && typeof value === 'object' ? value as Partial<EditorTrackSettings> : {};
  const clean = (kind: EditorTrackKind): EditorTrackControlState => ({
    locked: source[kind]?.locked === true,
    hidden: source[kind]?.hidden === true,
    muted: source[kind]?.muted === true,
  });
  return { video: clean('video'), music: clean('music'), overlays: clean('overlays') };
}
